import PropertyType from './PropertyType';
import SoldWithin from './SoldWithin';
import ListedWithin from './ListedWithin';
import Radius from './Radius';
import SalePriceMin from './SalePriceMin';
import SalePriceMax from './SalePriceMax';
import UpdateFilters from './UpdateFilters';
import LandSizeRange from './LandSizeRange';

const FilterFields = {
  PropertyType,
  Radius,
  SoldWithin,
  ListedWithin,
  LandSizeRange,
  SalePriceMin,
  SalePriceMax,
  UpdateFilters,
};

export default FilterFields;